module.exports = __webpack_public_path__ + "img/i4technology-logo.207f7655.png";